import { Icon } from '@chakra-ui/react';
import React from 'react';

const Menu = ({ ...rest }) => (
  <Icon
    width="16px"
    height="6px"
    viewBox="0 0 18 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      id="Vector"
      d="M1 1H17M9 7.00001L17 7"
      stroke="#0075FF"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
  </Icon>
);

export default Menu;
